<template>
  <div class="page">
    <div class="container">
      <div class="page__row">
        <div class="heritage__animation">
          <div class="page__inner">
            <h1 class="title title_red page__title page__title_upper">Наследие</h1>
            <p class="lead page__lead">Каждое действие сегодня формирует будущее и одновременно оставляет след в истории. Нам важно, какое влияние оказывают результаты нашей работы на мир клиента и мир в целом</p>
          </div>
          <div class="page__inner">
            <h1 class="title title_red page__title page__title_upper">Созидание</h1>
            <p class="lead page__lead">Мы предлагаем нелинейные подходы,<br> даже если задача кажется стандартной</p>
          </div>
          <div class="page__inner">
            <h1 class="title title_red page__title page__title_upper">Сотрудничество</h1>
            <p class="lead page__lead">Объединяя все направления коммуникационной индустрии через людей, знания, технологии, связи, бренды и&nbsp;идеи, мы&nbsp;создаем качество для клиента, для себя и&nbsp;рынка в&nbsp;целом</p>
          </div>
        </div>
      </div>
    </div>

    <missionSvg v-if="$isVisibleBg" />

    <page-footer :next="{ name: 'creation' }" />
  </div>
</template>

<script>
import { TimelineMax, TweenMax } from 'gsap'
import missionSvg from '@/components/missionSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '../mixins/route'

export default {
  name: 'heritage',
  mixins: [RouteMixin],
  components: {
    missionSvg,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.mission-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__title', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.page__lead', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__lead', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__title', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.mission-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
